import { useState } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import {
    customTabStylesCombineTheme,
    selectedTabStylesCombineTheme,
} from '@/constants';
import LoginsAuditTable from './table/LoginsAuditTable';
import NumbersAuditTable from './table/NumbersAuditTable';
import UsersAuditTable from './table/UsersAuditTable';

export default function Audit() {
    const { darkMode } = useSelector((state) => state.settings);
    const tabList = ['Numbers', 'Users', 'Logins'];
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <>
            <h1 className="mb-2 text-[2.5rem] font-medium">
                {tabList[tabIndex] + ' Audit'}
            </h1>
            <Tabs onChange={(index) => setTabIndex(index)}>
                <TabList borderBottom={0}>
                    {tabList.map((tab, idx) => (
                        <Tab
                            key={`${idx} - ${tab}`}
                            sx={{
                                ...customTabStylesCombineTheme,
                                color: darkMode
                                    ? 'rgba(255, 255, 255)'
                                    : 'inherit',
                            }}
                            _selected={selectedTabStylesCombineTheme}>
                            {tab}
                        </Tab>
                    ))}
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <NumbersAuditTable />
                    </TabPanel>
                    <TabPanel>
                        <UsersAuditTable />
                    </TabPanel>
                    <TabPanel>
                        <LoginsAuditTable />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </>
    );
}
